/**
 * @generated SignedSource<<c438f5f6cf9d026c1facdf40c69f87ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserHasNoAuthorisationScreen_BrandFragment$data = {
  readonly brandColorHex: string;
  readonly brandUrl: string;
  readonly icon: {
    readonly name: string;
    readonly url: string | null;
  } | null;
  readonly id: string;
  readonly " $fragmentType": "UserHasNoAuthorisationScreen_BrandFragment";
};
export type UserHasNoAuthorisationScreen_BrandFragment$key = {
  readonly " $data"?: UserHasNoAuthorisationScreen_BrandFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserHasNoAuthorisationScreen_BrandFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserHasNoAuthorisationScreen_BrandFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "brandColorHex",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "brandUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "icon",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Brand",
  "abstractKey": null
};

(node as any).hash = "f21a679712401c205d7abe404a7afc0c";

export default node;
